import { useEffect } from "react";
import { Grid } from "@mui/material";
import ModalComponent from "../../components/modals";
import LaddaButton from "../../components/buttons/laddaButton";
import FormTextField from "../../components/textField/formTextField";
import SimpleSelect from "../../components/selects/simpleSelect";

import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import "./styles.css";

const validationSchema = yup.object().shape({
  reason_id: yup.string().required("El motivo es obligatorio"),
  comment: yup.string().max(500, "Máximo 500 caracteres"),
  assignee_id: yup.string().required("Debe seleccionar un usuario")
});

const JustifyTaskModal = ({
  open,
  handleClose,
  task,
  onConfirm,
  reasonsOptions = [],
  assignableUsers = [],
  defaultAssigneeId = ""
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      reason_id: "",
      comment: "",
      assignee_id: ""
    }
  });

  useEffect(() => {
    if (!open) return;
    reset({
      reason_id: "",
      comment: "",
      assignee_id: defaultAssigneeId || ""
    });
  }, [open, reset, defaultAssigneeId]);

  const handleCloseModal = () => {
    reset();
    handleClose?.();
  };

  const onSubmit = (formData) => {
    const payload = {
      reason_id: formData.reason_id,
      comment: (formData.comment || "").trim(),
      assignee_id: formData.assignee_id
    };

    onConfirm?.(payload);
  };

  const fallbackReasons =[
          { name: "Incapacidad temporal por enfermedad común", value: 1 },
          { name: "Incapacidad por accidente", value: 2 },
          { name: "Incapacidad por accidente laboral", value: 3 },
          { name: "Procedimientos médicos", value: 4 },
          { name: "Hospitalización", value: 5 },
          { name: "Enfermedades contagiosas", value: 6 },
          { name: "Incapacidad por maternidad/paternidad", value: 7 }
        ];

  return (
    <ModalComponent
      open={open}
      handleClose={handleCloseModal}
      title={"Registrar actividad justificada"}
      width={"700px"}
      actions={
        <div className="j-center w-complete">
          <LaddaButton
            width={"220px"}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            <div className="HContainer align-center">
              <p className="button_text">Guardar justificación</p>
            </div>
          </LaddaButton>
        </div>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ marginTop: 8, width: "95%" }}>
          {task?.description && (
            <p className="detail-label" style={{ marginBottom: 12 }}>
              <strong>Tarea:</strong> {task.description}
            </p>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <p className="blueLabelForm">Motivo de la actividad</p>
              <SimpleSelect
                name="reason_id"
                control={control}
                options={fallbackReasons}
                error={errors?.reason_id}
                margin={"0"}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <p className="blueLabelForm">Asignar a usuario</p>
              <SimpleSelect
                name="assignee_id"
                control={control}
                options={assignableUsers}
                error={errors?.assignee_id}
                margin={"0"}
              />
            </Grid>

            <Grid item xs={12}>
              <p className="blueLabelForm">Comentario / Detalle</p>
              <FormTextField
                name="comment"
                control={control}
                isTextArea={true}
                error={errors?.comment}
                maxLength={500}
                rows={4}
                margin={"5px 0"}
                placeholder="Describe brevemente la razón y el contexto (máx. 500 caracteres)..."
              />
              <p
                className="detail-helper"
                style={{ fontSize: 12, color: "#888", marginTop: 4 }}
              >
                Este comentario quedará asociado a la actividad justificada y al
                usuario seleccionado.
              </p>
            </Grid>
          </Grid>
        </div>
      </form>
    </ModalComponent>
  );
};

export default JustifyTaskModal;
